import React from 'react';

import { Flex, LssProp, Skeleton, useBreakpoint } from '@lucidhq/lucidium';

import { useIPMatchingContext } from './IPMatchingProvider';
import { IPMatchingSection } from './IPMatchingSection';
import { IPMatchingSectionDescription } from './IPMatchingSectionDescription';

const ipManagementContainerLss: LssProp = {
  flexDirection: 'column',
  minWidth: '61.5rem',
  borderRadius: 'lg',
  bg: 'gray100',
  minHeight: 'fit-content',
  gap: '0.5rem',
  padding: '2.5rem 3rem',
  marginTop: '0.75rem',
  alignSelf: 'center',
  mobile: {
    minWidth: '30.75rem',
    flex: 0
  }
};

const loadingContainerLss: LssProp = {
  alignSelf: 'center',
  marginTop: '0.75',
  mobile: {
    minWidth: '30.75rem',
    maxWidth: '58rem',
    flex: 0
  },
  tablet: {
    maxWidth: '70rem'
  }
};

export const IPManagementSection = () => {
  const { isLoadingIPMatching } = useIPMatchingContext();
  const isTablet = useBreakpoint('tablet');

  if (isLoadingIPMatching)
    return (
      <Flex lss={loadingContainerLss}>
        <Skeleton
          ariaLabel="rect"
          variant="rect"
          width={`${isTablet ? '70.875' : '32.5'}rem`}
          height="12.5rem"
          animation="wave"
        />
      </Flex>
    );

  return (
    <Flex lss={ipManagementContainerLss}>
      <IPMatchingSection />
      <IPMatchingSectionDescription />
      {/* TODO: integrate IP Filtering here when available */}
    </Flex>
  );
};
